/**
 * Translation Loader for Cyber Schooling App
 *
 * This file dynamically imports all 82 language translations from individual files.
 * Each language is stored in /languages/xx.js for better modularity and performance.
 */

// Import all 82 languages
import { af } from './languages/af.js';
import { am } from './languages/am.js';
import { ar } from './languages/ar.js';
import { as } from './languages/as.js';
import { ay } from './languages/ay.js';
import { bg } from './languages/bg.js';
import { bn } from './languages/bn.js';
import { brx } from './languages/brx.js';
import { cs } from './languages/cs.js';
import { da } from './languages/da.js';
import { de } from './languages/de.js';
import { doi } from './languages/doi.js';
import { el } from './languages/el.js';
import { en } from './languages/en.js';
import { es } from './languages/es.js';
import { fa } from './languages/fa.js';
import { ff } from './languages/ff.js';
import { fi } from './languages/fi.js';
import { fil } from './languages/fil.js';
import { fr } from './languages/fr.js';
import { gn } from './languages/gn.js';
import { gu } from './languages/gu.js';
import { ha } from './languages/ha.js';
import { he } from './languages/he.js';
import { hi } from './languages/hi.js';
import { hr } from './languages/hr.js';
import { ht } from './languages/ht.js';
import { hu } from './languages/hu.js';
import { id } from './languages/id.js';
import { ig } from './languages/ig.js';
import { it } from './languages/it.js';
import { ja } from './languages/ja.js';
import { ka } from './languages/ka.js';
import { kk } from './languages/kk.js';
import { km } from './languages/km.js';
import { kn } from './languages/kn.js';
import { ko } from './languages/ko.js';
import { kok } from './languages/kok.js';
import { ks } from './languages/ks.js';
import { lo } from './languages/lo.js';
import { mai } from './languages/mai.js';
import { mg } from './languages/mg.js';
import { ml } from './languages/ml.js';
import { mn } from './languages/mn.js';
import { mni } from './languages/mni.js';
import { mr } from './languages/mr.js';
import { ms } from './languages/ms.js';
import { my } from './languages/my.js';
import { nah } from './languages/nah.js';
import { ne } from './languages/ne.js';
import { nl } from './languages/nl.js';
import { no } from './languages/no.js';
import { or } from './languages/or.js';
import { pa } from './languages/pa.js';
import { pl } from './languages/pl.js';
import { ps } from './languages/ps.js';
import { pt_BR } from './languages/pt-BR.js';
import { pt } from './languages/pt.js';
import { qu } from './languages/qu.js';
import { ro } from './languages/ro.js';
import { ru } from './languages/ru.js';
import { rw } from './languages/rw.js';
import { sa } from './languages/sa.js';
import { sd } from './languages/sd.js';
import { sk } from './languages/sk.js';
import { so } from './languages/so.js';
import { sv } from './languages/sv.js';
import { sw } from './languages/sw.js';
import { ta } from './languages/ta.js';
import { te } from './languages/te.js';
import { th } from './languages/th.js';
import { ti } from './languages/ti.js';
import { tr } from './languages/tr.js';
import { uk } from './languages/uk.js';
import { ur } from './languages/ur.js';
import { uz } from './languages/uz.js';
import { vi } from './languages/vi.js';
import { wo } from './languages/wo.js';
import { xh } from './languages/xh.js';
import { yo } from './languages/yo.js';
import { zh } from './languages/zh.js';
import { zu } from './languages/zu.js';
import { languageMetadata } from './languageMetadata.js';

// Combine all translations into a single object
const translations = {
    af, am, ar, as, ay, bg, bn, brx, cs, da, de, doi, el, en, es, fa, ff, fi, fil, fr, gn, gu, ha, he, hi, hr, ht, hu, id, ig, it, ja, ka, kk, km, kn, ko, kok, ks, lo, mai, mg, ml, mn, mni, mr, ms, my, nah, ne, nl, no, or, pa, pl, ps, pt_BR, pt, qu, ro, ru, rw, sa, sd, sk, so, sv, sw, ta, te, th, ti, tr, uk, ur, uz, vi, wo, xh, yo, zh, zu
};

export { translations, languageMetadata };
